import { SocialShareLinks } from '@carbonify/ui';
import { isBrowser } from 'utils/dom';

import styles from './BlogSocialLinks.module.css';

export default function BlogSocialLinks() {
  return (
    <SocialShareLinks
      url={isBrowser ? window.location.href : '#'}
      title={isBrowser ? document.title : undefined}
      className={styles.links}
      label={<span className={styles.label}>Diesen Artikel teilen</span>}
    />
  );
}
